/**
 * holz4home — Ambassador-Landingpage: Step-1-Formular.
 * Persistiert Profil-Daten in cart.attributes + sessionStorage,
 * berechnet das Wunsch-Warenwert-Limit per Tier-Konfig (Maximum
 * ueber alle angegebenen Plattformen) und redirected in den Shop.
 */
(function () {
  'use strict';

  const form = document.querySelector('#h4h-amb-form');
  if (!form) return;

  const PLATS = ['instagram', 'tiktok', 'youtube', 'pinterest'];
  const errBox = form.querySelector('.h4h-amb-form__err');
  const submitBtn = form.querySelector('.h4h-amb-form__submit');

  // Tier-Konfig aus dem data-Attribut (von Liquid gerendert)
  let tiers = [];
  try { tiers = JSON.parse(form.dataset.tiers || '[]'); } catch (_) {}

  // Plattform-Toggle: Felder zeigen / verbergen
  form.querySelectorAll('.h4h-amb-form__plat').forEach(box => {
    const cb = box.querySelector('input[type="checkbox"]');
    const sync = () => box.classList.toggle('is-on', cb.checked);
    cb.addEventListener('change', sync);
    sync();
  });

  function maxFollowers(platforms) {
    return platforms.reduce((m, p) => Math.max(m, p.followers || 0), 0);
  }

  function tierFor(followers) {
    // Tiers sind sortiert nach max_followers aufsteigend.
    // Wir nehmen den ersten Tier, dessen Schwelle >= followers.
    const sorted = [...tiers].sort((a, b) => a.max_followers - b.max_followers);
    return sorted.find(t => followers <= t.max_followers) || sorted[sorted.length - 1] || null;
  }

  function showErr(msg) {
    errBox.textContent = msg;
    errBox.classList.add('is-shown');
    errBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function clearErr() { errBox.classList.remove('is-shown'); }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErr();

    const fd = new FormData(form);
    const name = (fd.get('name') || '').toString().trim();
    const email = (fd.get('email') || '').toString().trim();

    // Plattform-Eintraege sammeln (nur aktive)
    const platforms = PLATS.map(p => {
      if (!fd.get('plat_' + p)) return null;
      const handle = (fd.get(p + '_handle') || '').toString().trim().replace(/^@/, '');
      const followers = parseInt(fd.get(p + '_followers') || '0', 10) || 0;
      if (!handle) return { platform: p, handle: '', followers, _err: 'handle' };
      return { platform: p, handle: '@' + handle, followers };
    }).filter(Boolean);

    if (!name) return showErr('Bitte gib deinen Namen an.');
    if (!email) return showErr('Bitte gib eine E-Mail-Adresse an.');
    if (!platforms.length) return showErr('Bitte mindestens eine Plattform auswaehlen.');
    if (platforms.some(p => !p.handle)) return showErr('Fuer jede ausgewaehlte Plattform brauchen wir auch dein Handle.');

    // Tier berechnen (Maximum ueber alle Plattformen)
    const followers = maxFollowers(platforms);
    const tier = tierFor(followers);

    const session = (crypto.randomUUID && crypto.randomUUID()) ||
                    ('amb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));

    const profile = { session, name, email, platforms, max_followers: followers, tier };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Wir bereiten den Shop vor ...';

    try {
      // 1. Profil in Shopify Cart Attributes ablegen
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '_h4h_amb_session': session,
            '_h4h_amb_name': name,
            '_h4h_amb_email': email,
            '_h4h_amb_platforms': JSON.stringify(platforms),
            '_h4h_amb_max_followers': String(followers),
            '_h4h_amb_tier_limit_eur': tier ? String(tier.warenwert_eur) : '0',
          },
        }),
      });

      // 2. sessionStorage fuer Overlay
      sessionStorage.setItem('h4h_amb_profile', JSON.stringify(profile));
      sessionStorage.setItem('h4h_amb_tiers', JSON.stringify(tiers));
      sessionStorage.setItem('h4h_amb_active', '1');

      // 3. Redirect in Shop (bestehender Cart bleibt erhalten)
      const target = form.dataset.shopUrl || '/collections/all';
      window.location.href = target;
    } catch (err) {
      console.error('[ambassador-landing] submit failed', err);
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Erneut versuchen';
      showErr('Etwas ist schiefgegangen. Lade die Seite einmal neu und versuche es noch einmal.');
    }
  });
})();
